import React from "react";
import {
  Skeleton,
  TableRow,
  TableCell,
} from "@mui/material";

const SkeletonLoadingTable = ({ countRows, countColumns }) => {
  return new Array(countRows).fill(0).map((_, i) => {
    return (
      <TableRow key={`TableRow-${ i }`}>
        {new Array(countColumns).fill(0).map((_, j) => (
          <TableCell key={`TableRow-${ i }-${ j }`}><Skeleton/></TableCell>
        ))}
      </TableRow>
    )
  })
};

export default SkeletonLoadingTable
